import { AppBar, Grid, Toolbar, Typography, IconButton, MenuItem, Menu, Button, Box, Drawer, withStyles, ListItemIcon, } from '@material-ui/core';
import React from 'react';
import Scroll from './Scroll'
import { Link, useLocation } from 'react-router-dom';
import MenuIcon from '@material-ui/icons/Menu';

import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import dpalogo from "../asset/images/dpa_main_logo.svg";
import smdpalogo from "../asset/images/dpalogo.svg";
import oraclelogo from "../asset/images/oracle_logo.svg";
import ibmlogo from "../asset/images/ibm/ibm_logo.webp";
import clickuplogo from "../asset/images/clickup_logo.webp";


import CloseIcon from '@mui/icons-material/Close';
import MuiAccordion from '@material-ui/core/Accordion';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';

import LetsConnectCTA from './forms/LetsConnectCTA';

import smoracle from "../asset/images/sm_oracle.png";
import smibm from "../asset/images/sm_ibm.webp";
import smclickup from "../asset/images/sm_clickup.webp";
import salesforce from "../asset/images/salesforce.svg";
import smsalesforce from "../asset/images/smsalesforce.webp";
import braincube from "../asset/images/braincube.svg";
import smbraincube from "../asset/images/smbraincube.webp";
import databricks from "../asset/images/databricks_logo.svg";
import smdatabricks from "../asset/images/sm_databricks.webp";
import IGSALogo from "../asset/images/igsa_logo.webp";
import IGSALogosm from "../asset/images/igsa_logo_sm.webp";

const Accordion = withStyles({
  root: {
    border: '1px solid rgba(0, 0, 0, .125)',
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&:before': {
      display: 'none',
    },
    '&$expanded': {
      margin: 'auto',
    },
  },
  expanded: {},
})(MuiAccordion);


const AccordionSummary = withStyles({
  root: {
    borderBottom: '1px solid rgba(0, 0, 0, .125)',
    marginBottom: -1,
    minHeight: 56,
    '&$expanded': {
      minHeight: 56,
    },
  },
  content: {
    '&$expanded': {
      margin: '12px 0',
    },
  },
  expanded: {},
})(MuiAccordionSummary);


const AccordionDetails = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiAccordionDetails);





export default function Header() {

  const [anchorE2, setAnchorE2] = React.useState(null);

  const handleClick = (event) => {
    setAnchorE2(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorE2(null);
  };

  const [anchorEl, setAnchorEl] = React.useState(null);

  const isMenuOpen = Boolean(anchorEl);

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const menuId = 'primary-search-account-menu';


  const [state, setState] = React.useState({
  });

  const toggleDrawer = (anchor, open) => (event) => {

    if (event.type === 'right' && (event.key === 'right')) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };


  // Insight Dropdown started
  const [anchorEins, setAnchorEins] = React.useState(null);

  const handleClickins = (event) => {
    setAnchorEins(event.currentTarget);
  };

  const handleCloseins = () => {
    setAnchorEins(null);
  };



  // Oracle Dropdown started
  const [anchorEOra, setAnchorEOra] = React.useState(null);

  const handleClickOra = (event) => {
    setAnchorEOra(event.currentTarget);
  };

  const handleCloseOra = () => {
    setAnchorEOra(null);
  };


  const [expanded, setExpanded] = React.useState('false');

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);

  };

  const list = (anchor) => (

    <Box className='mobilemenuview' sx={{ width: 300 }} role="presentation">


      <Box mb={1} mt={1} mr={2} className='al_right'>
        <IconButton className='Close_btn' variant="contained" onClick={toggleDrawer(anchor, false)}>
          <CloseIcon fontSize='small' color='primary' />
        </IconButton>
      </Box>

      <Box >

        <Accordion expanded={expanded === 'panel0'} onChange={handleChange('panel0')}>
          <AccordionSummary component={Link} to='/' aria-controls="panel0d-content" id="panel0d-header" onClick={toggleDrawer(anchor, false)}>
            <Button disableRipple className={`menutt ${isActive(['/']) ? 'active_menu' : ''}`}>Home</Button>
          </AccordionSummary>
        </Accordion>


        <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
          <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
            <Button endIcon={<ArrowDropDownIcon />} disableRipple className={`menutt ${isActive(['/data-solution-in-us', '/business-intelligence-solution', '/artificial-intelligence-solutions', '/leading-research-solution-company', '/risk-management-company-in-us', '/small-business-administration', '/catastrophe-modeling-services', '/cloud-services', '/quantum-computing', '/ecopulse', '/coffeepulse', '/creditpulse', '/analystpulse', '/fidelitypulse', '/robopulse', '/environmental-social-and-governance-for-financial-institutions-and-enterprise-businesses', '/consultant-database-management', '/crm-solutions', '/investor-relations-solutions', '/request-for-proposals-solutions', '/due-diligence-questionnaires-solutions', '/consultant-database-management-solutions', '/customer-relationship-management-solutions', '/bridge-lending-solutions', '/fund-management-and-private-equity-support-solutions']) ? 'active_menu' : ''}`}>Solutions</Button>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={2} alignItems="top">
              <Grid item lg={12} md={12} sm={12} xs={12}>

                <Typography className="menuheading">Services</Typography>

                <Box className='bdd'>
                  <Box component={Link} to='/artificial-intelligence-solutions' className={`linkitem ${isActive(['/artificial-intelligence-solutions']) ? 'active_drop_menu' : ''}`}>
                    <MenuItem onClick={toggleDrawer(anchor, false)} ><span>Artificial Intelligence</span>
                    </MenuItem>
                    <Typography className='menudscrp'>Empower your business with AI to stay ahead</Typography>
                  </Box>
                </Box>

                <Box className='bdd'>
                  <Box component={Link} to='/bridge-lending-solutions' className={`linkitem ${isActive(['/bridge-lending-solutions']) ? 'active_drop_menu' : ''}`}>
                    <MenuItem onClick={toggleDrawer(anchor, false)} ><span>Bridge Lending Solutions</span>
                    </MenuItem>
                    <Typography className='menudscrp'>Streamline your bridge lending operations with expert risk management and efficient processes to stay ahead in a competitive market.</Typography>
                  </Box>
                </Box>

                <Box className='bdd'>
                  <Box component={Link} to='/catastrophe-modeling-services' className={`linkitem ${isActive(['/catastrophe-modeling-services']) ? 'active_drop_menu' : ''}`}>
                    <MenuItem onClick={toggleDrawer(anchor, false)} ><span>Catastrophe Modeling Services</span>
                    </MenuItem>
                    <Typography className='menudscrp'>Optimize risk strategies with CAT modeling</Typography>
                  </Box>
                </Box>

                <Box className='bdd'>
                  <Box component={Link} to='/cloud-services' className={`linkitem ${isActive(['/cloud-services']) ? 'active_drop_menu' : ''}`}>
                    <MenuItem onClick={toggleDrawer(anchor, false)} ><span>Cloud Services</span>
                    </MenuItem>
                    <Typography className='menudscrp'>Migration, Optimization, Monitoring & Multi-Cloud Solutions Empower Your Business with Cutting-Edge Cloud Services</Typography>
                  </Box>
                </Box>

                <Box className='bdd'>
                  <Box component={Link} to='/data-solution-in-us' className={`linkitem ${isActive(['/data-solution-in-us']) ? 'active_drop_menu' : ''}`}>
                    <MenuItem onClick={toggleDrawer(anchor, false)}><span>Data Solution</span>
                    </MenuItem>
                    <Typography className='menudscrp'>Let us solve 80% of your problems</Typography>
                  </Box>
                </Box>

                <Box className='bdd'>
                  <Box component={Link} to='/business-intelligence-solution' className={`linkitem ${isActive(['/business-intelligence-solution']) ? 'active_drop_menu' : ''}`}>
                    <MenuItem onClick={toggleDrawer(anchor, false)}><span>Data Visualization & BI Dashboards</span>
                    </MenuItem>
                    <Typography className='menudscrp'>Drive strategic decisions with essential data insights</Typography>
                  </Box>
                </Box>

                <Box className='bdd'>
                  <Box component={Link} to='/fund-management-and-private-equity-support-solutions' className={`linkitem ${isActive(['/fund-management-and-private-equity-support-solutions']) ? 'active_drop_menu' : ''}`}>
                    <MenuItem onClick={toggleDrawer(anchor, false)}><span>Fund Management & PE Support Solutions</span>
                    </MenuItem>
                    <Typography className='menudscrp'>Drive strategic decisions with essential data insights and tailored solutions for fund management and private equity support.</Typography>
                  </Box>
                </Box>

                <Box className='bdd'>
                  <Box component={Link} to='/environmental-social-and-governance-for-financial-institutions-and-enterprise-businesses' className={`linkitem ${isActive(['/environmental-social-and-governance-for-financial-institutions-and-enterprise-businesses']) ? 'active_drop_menu' : ''}`}>
                    <MenuItem endIcon={<ArrowDropDownIcon />} onClick={toggleDrawer(anchor, false)} ><span>ESG</span>
                    </MenuItem>
                    <Typography className='menudscrp'>ESG solutions for sustainable growth and compliance</Typography>
                  </Box>
                  <Box className='esgopbx' pt={1} pb={"3px"}>
                    <Box component={Link} onClick={handleMenuClose} to='/environmental-social-and-governance-for-financial-institutions-and-enterprise-businesses' className={`linkitem ${isActive(['/environmental-social-and-governance-for-financial-institutions-and-enterprise-businesses']) ? 'active_drop_menu' : ''}`}  >
                      <MenuItem onClick={toggleDrawer(anchor, false)}><span >ESG</span>
                      </MenuItem>
                    </Box>

                    <Box component={Link} onClick={handleMenuClose} to='/esg-insights/esg-whitepaper' className={`linkitem ${isActive(['/esg-insights/esg-whitepaper']) ? 'active_drop_menu' : ''}`}>
                      <MenuItem onClick={toggleDrawer(anchor, false)}><span >ESG Insight</span>
                      </MenuItem>
                    </Box>

                    <Box component={Link} onClick={handleMenuClose} to='/environmental-social-and-governance-for-financial-institutions-and-enterprise-businesses#esg-executable-roundtable' className={`linkitem ${isActive(['/environmental-social-and-governance-for-financial-institutions-and-enterprise-businesses#esg-executable-roundtable']) ? 'active_drop_menu' : ''}`}>
                      <MenuItem onClick={toggleDrawer(anchor, false)}><span >ESG Roundtable</span>
                      </MenuItem>
                    </Box>

                    <Box component={Link} onClick={handleMenuClose} to='/empowering-esg-investment-with-real-time-analytics' className={`linkitem ${isActive(['/empowering-esg-investment-with-real-time-analytics']) ? 'active_drop_menu' : ''}`}>
                      <MenuItem onClick={toggleDrawer(anchor, false)}><span >ESG Products</span>
                      </MenuItem>
                    </Box>
                  </Box>
                </Box>

                <Box className='bdd'>
                  <Box component={Link} to='/investor-relations-solutions' className={`linkitem ${isActive(['/investor-relations-solutions']) ? 'active_drop_menu' : ''}`}>
                    <MenuItem endIcon={<ArrowDropDownIcon />} onClick={toggleDrawer(anchor, false)} ><span>Investor Relations Solutions</span>
                    </MenuItem>
                    <Typography className='menudscrp'>Transform Your Investor Relations Today</Typography>
                  </Box>

                  <Box className='invebx' pt={1}>
                    <Box component={Link} to='/investor-relations-solutions' className={`linkitem ${isActive(['/investor-relations-solutions']) ? 'active_drop_menu' : ''}`}>
                      <MenuItem onClick={toggleDrawer(anchor, false)}><span>Investor Relations Solutions</span>
                      </MenuItem>
                    </Box>

                    <Box component={Link} to='/request-for-proposals-solutions' className={`linkitem ${isActive(['/request-for-proposals-solutions']) ? 'active_drop_menu' : ''}`}>
                      <MenuItem onClick={toggleDrawer(anchor, false)}><span>RFP Management Solutions</span>
                      </MenuItem>
                    </Box>

                    <Box component={Link} to='/due-diligence-questionnaires-solutions' className={`linkitem ${isActive(['/due-diligence-questionnaires-solutions']) ? 'active_drop_menu' : ''}`}>
                      <MenuItem onClick={toggleDrawer(anchor, false)}><span>Due Diligence questionnaires</span>
                      </MenuItem>
                    </Box>

                    <Box component={Link} to='/consultant-database-management-solutions' className={`linkitem ${isActive(['/consultant-database-management-solutions']) ? 'active_drop_menu' : ''}`}>
                      <MenuItem onClick={toggleDrawer(anchor, false)}><span>Consultant Database Management</span>
                      </MenuItem>
                    </Box>

                    <Box component={Link} to='/customer-relationship-management-solutions' className={`linkitem ${isActive(['/customer-relationship-management-solutions']) ? 'active_drop_menu' : ''}`}>
                      <MenuItem onClick={toggleDrawer(anchor, false)}><span>Customer Relationship Management</span>
                      </MenuItem>
                    </Box>

                  </Box>
                </Box>

                <Box className='bdd'>
                  <Box component={Link} to='/leading-research-solution-company' className={`linkitem ${isActive(['/leading-research-solution-company']) ? 'active_drop_menu' : ''}`}>
                    <MenuItem onClick={toggleDrawer(anchor, false)} ><span>Research Solution</span>
                    </MenuItem>
                    <Typography className='menudscrp'>The analysis that augments your quality of decisions</Typography>
                  </Box>
                </Box>

                <Box className='bdd'>
                  <Box component={Link} to='/risk-management-company-in-us' className={`linkitem ${isActive(['/risk-management-company-in-us']) ? 'active_drop_menu' : ''}`}>
                    <MenuItem onClick={toggleDrawer(anchor, false)} ><span>Risk Management</span>
                    </MenuItem>
                    <Typography className='menudscrp'>The analysis that augments your quality of decisions</Typography>
                  </Box>
                </Box>

                <Box className='bdd'>
                  <Box component={Link} to='/small-business-administration' className={`linkitem ${isActive(['/small-business-administration']) ? 'active_drop_menu' : ''}`}>
                    <MenuItem onClick={toggleDrawer(anchor, false)} ><span>Small Business Administration</span>
                    </MenuItem>
                    <Typography className='menudscrp'>Streamline SBA lending with precision and efficiency</Typography>
                  </Box>
                </Box>

              </Grid>

            </Grid>
          </AccordionDetails>
        </Accordion>


        <Accordion expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
          <AccordionSummary aria-controls="panel2d-content" id="panel2d-header"  >
            <Button endIcon={<ArrowDropDownIcon />} disableRipple className={`menutt ${isActive(['/case-studies', '/articles', '/blog', '/newsletter', '/podcast', '/whitepaper', '/magazine']) ? 'active_menu' : ''}`}>Insights</Button>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={2} alignItems="top">
              <Grid item lg={12} md={12} sm={12} xs={12}>

                <Box className='bdd'>
                  <Box component={Link} to='/case-studies' className={`linkitem ${isActive(['/case-studies']) ? 'active_drop_menu' : ''}`}>
                    <MenuItem onClick={toggleDrawer(anchor, false)}><span> Success Stories </span>
                    </MenuItem>
                  </Box>
                </Box>


                <Box className='bdd'>
                  <Box component={Link} to='/articles' className={`linkitem ${isActive(['/articles']) ? 'active_drop_menu' : ''}`}>
                    <MenuItem onClick={toggleDrawer(anchor, false)}><span> Articles </span>
                    </MenuItem>
                  </Box>
                </Box>

                <Box className='bdd'>
                  <Box component={Link} to='/blog' className={`linkitem ${isActive(['/blog']) ? 'active_drop_menu' : ''}`}>
                    <MenuItem onClick={toggleDrawer(anchor, false)}><span> Blogs </span>
                    </MenuItem>
                  </Box>
                </Box>

                <Box className='bdd'>
                  <Box component={Link} to='/newsletter' className={`linkitem ${isActive(['/newsletter']) ? 'active_drop_menu' : ''}`}>
                    <MenuItem onClick={toggleDrawer(anchor, false)}><span> Newsletter </span>
                    </MenuItem>
                  </Box>
                </Box>

                <Box className='bdd'>
                  <Box component={Link} to='/podcast' className={`linkitem ${isActive(['/podcast']) ? 'active_drop_menu' : ''}`}>
                    <MenuItem onClick={toggleDrawer(anchor, false)}><span> Podcast </span>
                    </MenuItem>
                  </Box>
                </Box>

                {/* <Box className='bdd'>
                  <Box component={Link} to='/infographics' className={`linkitem ${isActive(['/infographics']) ? 'active_drop_menu' : ''}`}>
                    <MenuItem onClick={toggleDrawer(anchor, false)}><span> Infographic </span>
                    </MenuItem>
                  </Box>
                </Box> */}

                <Box className='bdd'>
                  <Box component={Link} to='/whitepaper' className={`linkitem ${isActive(['/whitepaper']) ? 'active_drop_menu' : ''}`}>
                    <MenuItem onClick={toggleDrawer(anchor, false)}><span> Whitepapers </span>
                    </MenuItem>
                  </Box>
                </Box>

                <Box>
                  <Box component={Link} to='/magazine' className={`linkitem ${isActive(['/magazine']) ? 'active_drop_menu' : ''}`}>
                    <MenuItem onClick={toggleDrawer(anchor, false)}><span> Magazine </span>
                    </MenuItem>
                  </Box>
                </Box>

              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>


        <Accordion expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
          <AccordionSummary component={Link} to='/life-as-a-decimal' aria-controls="panel3d-content" id="panel3d-header" onClick={toggleDrawer(anchor, false)}>
            <Button disableRipple className={`menutt ${isActive(['/life-as-a-decimal', '/our-culture', '/journey-of-a-decimal', '/dnyanodapi-dhanodapi', '/current-openings']) ? 'active_menu' : ''}`}>Careers</Button>
          </AccordionSummary>
        </Accordion>


        <Accordion expanded={expanded === 'panelPartner'} onChange={handleChange('panelPartner')}>
          <AccordionSummary aria-controls="panelPartnerd-content" id="panelPartnerd-header"  >
            <Button endIcon={<ArrowDropDownIcon />} disableRipple className={`menutt ${isActive(['/oracle', '/ibm', '/clickup-partnership', '/salesforce-crm-solutions', '/braincube', '/databricks', '/igsa-labs']) ? 'active_menu' : ''}`}>Partners</Button>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={2} alignItems="top">
              <Grid item lg={12} md={12} sm={12} xs={12}>

                <Box className='bdd partner_section'>
                  <Box component={Link} to='/oracle' className={`linkitem ${isActive(['/oracle']) ? 'active_drop_menu' : ''}`}>
                    <MenuItem onClick={toggleDrawer(anchor, false)}><span className='fx_c'>
                      <ListItemIcon>
                        <img loading="lazy" src={smoracle} className='sm_partner_logo' alt='Oracle' />
                      </ListItemIcon>Oracle</span>
                    </MenuItem>
                  </Box>
                </Box>

                <Box className='bdd partner_section'>
                  <Box component={Link} to='/ibm' className={`linkitem ${isActive(['/ibm']) ? 'active_drop_menu' : ''}`}>
                    <MenuItem onClick={toggleDrawer(anchor, false)}><span className='fx_c'>
                      <ListItemIcon>
                        <img loading="lazy" src={smibm} className='sm_partner_logo' alt='IBM' />
                      </ListItemIcon>IBM</span>
                    </MenuItem>
                  </Box>
                </Box>

                <Box className='bdd partner_section'>
                  <Box component={Link} to='/clickup-partnership' className={`linkitem ${isActive(['/clickup-partnership']) ? 'active_drop_menu' : ''}`}>
                    <MenuItem onClick={toggleDrawer(anchor, false)}><span className='fx_c'>
                      <ListItemIcon>
                        <img loading="lazy" src={smclickup} className='sm_partner_logo' alt='ClickUp' />
                      </ListItemIcon>ClickUp</span>
                    </MenuItem>
                  </Box>
                </Box>

                <Box className='bdd partner_section'>
                  <Box component={Link} to='/salesforce-crm-solutions' className={`linkitem ${isActive(['/salesforce-crm-solutions']) ? 'active_drop_menu' : ''}`}>
                    <MenuItem onClick={toggleDrawer(anchor, false)}><span className='fx_c'>
                      <ListItemIcon>
                        <img loading="lazy" src={smsalesforce} className='sm_partner_logo' alt='ClickUp' />
                      </ListItemIcon>Salesforce</span>
                    </MenuItem>
                  </Box>
                </Box>

                <Box className='bdd partner_section'>
                  <Box component={Link} to='/braincube' className={`linkitem ${isActive(['/braincube']) ? 'active_drop_menu' : ''}`}>
                    <MenuItem onClick={toggleDrawer(anchor, false)}><span className='fx_c'>
                      <ListItemIcon>
                        <img loading="lazy" src={smbraincube} className='sm_partner_logo' alt='Braincube' />
                      </ListItemIcon>Braincube</span>
                    </MenuItem>
                  </Box>
                </Box>

                <Box className='bdd partner_section'>
                  <Box component={Link} to='/databricks' className={`linkitem ${isActive(['/databricks']) ? 'active_drop_menu' : ''}`}>
                    <MenuItem onClick={toggleDrawer(anchor, false)}><span className='fx_c'>
                      <ListItemIcon>
                        <img loading="lazy" src={smdatabricks} className='sm_partner_logo' alt='Databricks' />
                      </ListItemIcon>Databricks</span>
                    </MenuItem>
                  </Box>
                </Box>


                <Box className='bdd partner_section'>
                  <Box component={Link} to='/igsa-labs' className={`linkitem ${isActive(['/igsa-labs']) ? 'active_drop_menu' : ''}`}>
                    <MenuItem onClick={toggleDrawer(anchor, false)}><span className='fx_c'>
                      <ListItemIcon>
                        <img loading="lazy" src={IGSALogosm} className='sm_partner_logo' alt='IGSA Labs' />
                      </ListItemIcon>IGSA Labs</span>
                    </MenuItem>
                  </Box>
                </Box>

              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>


        <Accordion expanded={expanded === 'panel4'} onChange={handleChange('panel4')}>
          <AccordionSummary aria-controls="panel4d-content" id="panel4d-header" >
            <Button endIcon={<ArrowDropDownIcon />} disableRipple className={`menutt ${isActive(['/who-we-are', '/decimal-sutras', '/awards', '/management', '/csr', '/energy-efficiency', '/event', '/newsroom/media-feature']) ? 'active_menu' : ''}`}>About Us</Button>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={2} alignItems="top">
              <Grid item lg={12} md={12} sm={12} xs={12}>

                <Box className='bdd'>
                  <Box component={Link} to='/who-we-are' className={`linkitem ${isActive(['/who-we-are']) ? 'active_drop_menu' : ''}`}>
                    <MenuItem onClick={toggleDrawer(anchor, false)}><span>Our Story & Offerings</span>
                    </MenuItem>
                  </Box>
                </Box>

                <Box className='bdd'>
                  <Box component={Link} to='/decimal-sutras' className={`linkitem ${isActive(['/decimal-sutras']) ? 'active_drop_menu' : ''}`}>
                    <MenuItem onClick={toggleDrawer(anchor, false)}><span>Decimal Sutras</span>
                    </MenuItem>
                  </Box>
                </Box>

                <Box className='bdd'>
                  <Box component={Link} to='/awards' className={`linkitem ${isActive(['/awards']) ? 'active_drop_menu' : ''}`}>
                    <MenuItem onClick={toggleDrawer(anchor, false)}><span>Awards and Accolades</span>
                    </MenuItem>
                  </Box>
                </Box>

                {/* <Box className='bdd'>
                  <Box component={Link} to='/technologyedge' className={`linkitem ${isActive(['/technologyedge']) ? 'active_drop_menu' : ''}`}>
                    <MenuItem onClick={toggleDrawer(anchor, false)}><span>The Technology Edge</span>
                    </MenuItem>
                  </Box>
                </Box>

                <Box className='bdd'>
                  <Box component={Link} to='/valueproposition' className={`linkitem ${isActive(['/valueproposition']) ? 'active_drop_menu' : ''}`}>
                    <MenuItem onClick={toggleDrawer(anchor, false)}><span>Value Proposition</span>
                    </MenuItem>
                  </Box>
                </Box> */}

                <Box className='bdd'>
                  <Box component={Link} to='/management' className={`linkitem ${isActive(['/management']) ? 'active_drop_menu' : ''}`}>
                    <MenuItem onClick={toggleDrawer(anchor, false)}><span>Management Team</span>
                    </MenuItem>
                  </Box>
                </Box>

                {/* <Box className='bdd'>
                  <Box component={Link} to='/structure-innovation' className={`linkitem ${isActive(['/structure-innovation']) ? 'active_drop_menu' : ''}`}>
                    <MenuItem onClick={toggleDrawer(anchor, false)}><span>Structure of Innovation</span>
                    </MenuItem>
                  </Box>
                </Box> */}

                <Box className='bdd'>
                  <Box component={Link} to='/csr' className={`linkitem ${isActive(['/csr']) ? 'active_drop_menu' : ''}`}>
                    <MenuItem onClick={toggleDrawer(anchor, false)}><span>CSR</span>
                    </MenuItem>
                  </Box>
                </Box>

                <Box className='bdd'>
                  <Box component={Link} to='/energy-efficiency' className={`linkitem ${isActive(['/energy-efficiency']) ? 'active_drop_menu' : ''}`}>
                    <MenuItem onClick={toggleDrawer(anchor, false)}><span>Energy Efficiency</span>
                    </MenuItem>
                  </Box>
                </Box>
                <Box className='bdd'>
                  <Box component={Link} to='/event' className={`linkitem ${isActive(['/event']) ? 'active_drop_menu' : ''}`}>
                    <MenuItem onClick={toggleDrawer(anchor, false)}><span>Events</span>
                    </MenuItem>
                  </Box>
                </Box>

                <Box className='bdd'>
                  <Box component={Link} to='/newsroom/media-feature' className={`linkitem ${isActive(['/newsroom/media-feature']) ? 'active_drop_menu' : ''}`}>
                    <MenuItem onClick={toggleDrawer(anchor, false)}><span>News Room</span>
                    </MenuItem>
                  </Box>
                </Box>

              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>





        <Accordion expanded={expanded === 'panel6'} onChange={handleChange('panel6')}>
          <AccordionSummary aria-controls="panel6d-content" id="panel6d-header" >
            <LetsConnectCTA className="contact_sales_btn" btn_name="Contact Sales" />
          </AccordionSummary>
        </Accordion>



      </Box>
    </Box >
  );



  const location = useLocation();

  const isActive = (paths) => {
    return paths.some(path => location.pathname === (path));
  };


  return (
    <div className="grow">
      <Scroll showBelow={250} />
      <AppBar position="fixed" className="appnavbar" alignItems="center" data-aos="fade-down">
        <Toolbar>

          <Box className='loggo0 flx_center align_c'>
            {window.location.pathname === "/oracle" ? (
              <>
                <a href='/' onClick={() => { window.location.href = "/" }}><img loading="lazy" src={dpalogo} className='dpalogo withora' alt='Decimal Point Analytics' /></a>
                <a href='/' onClick={() => { window.location.href = "/" }}><img loading="lazy" src={smdpalogo} className='smdpalogo' alt='Decimal Point Analytics' /></a>
                <a href='/oracle' onClick={() => { window.location.href = "/oracle" }}><img loading="lazy" src={oraclelogo} className='oraclelogo' alt='Oracle Partner' /></a>

              </>
            ) : window.location.pathname === "/ibm" ? (
              <>
                <a href='/' onClick={() => { window.location.href = "/" }}><img loading="lazy" src={dpalogo} className='dpalogo withora' alt='Decimal Point Analytics' /></a>
                <a href='/' onClick={() => { window.location.href = "/" }}><img loading="lazy" src={smdpalogo} className='smdpalogo' alt='Decimal Point Analytics' /></a>
                <Box className='flx_fs ai_center'>
                  <a href='/ibm' onClick={() => { window.location.href = "/ibm" }}><img loading="lazy" src={ibmlogo} className='ibmlogo' alt='IBM Partner' /></a>

                  <Typography variant='h6' className='black fw5 mb0'> | &nbsp; Partner</Typography>
                </Box>
              </>
            ) : window.location.pathname === "/clickup-partnership" ? (
              <>
                <a href='/' onClick={() => { window.location.href = "/" }}><img loading="lazy" src={dpalogo} className='dpalogo withora' alt='Decimal Point Analytics' /></a>
                <a href='/' onClick={() => { window.location.href = "/" }}><img loading="lazy" src={smdpalogo} className='smdpalogo' alt='Decimal Point Analytics' /></a>
                <Box className='flx_fs ai_center' pt={'4px'}>
                  <a href='/clickup-partnership' onClick={() => { window.location.href = "/clickup-partnership" }}><img loading="lazy" src={clickuplogo} className='clickuplogo' alt='Clickup Partner' /></a>

                  <Typography variant='h6' className='black fw5 mb0'> | &nbsp; Partner</Typography>
                </Box>
              </>
            ) : window.location.pathname === "/salesforce-crm-solutions" ? (
              <>
                <a href='/' onClick={() => { window.location.href = "/" }}><img loading="lazy" src={dpalogo} className='dpalogo withora' alt='Decimal Point Analytics' /></a>
                <a href='/' onClick={() => { window.location.href = "/" }}><img loading="lazy" src={smdpalogo} className='smdpalogo' alt='Decimal Point Analytics' /></a>
                <Box className='flx_fs ai_center'>
                  <a href='/salesforce-crm-solutions' onClick={() => { window.location.href = "/salesforce-crm-solutions" }}><img loading="lazy" src={salesforce} className='salesforcelogo' alt='Salesforce Partner' /></a>
                  <Typography variant='h6' className='black fw5 mb0'> | &nbsp; Partner</Typography>
                </Box>
              </>
            ) : window.location.pathname === "/braincube" ? (
              <>
                <a href='/' onClick={() => { window.location.href = "/" }}><img loading="lazy" src={dpalogo} className='dpalogo withora' alt='Decimal Point Analytics' /></a>
                <a href='/' onClick={() => { window.location.href = "/" }}><img loading="lazy" src={smdpalogo} className='smdpalogo' alt='Decimal Point Analytics' /></a>
                <Box className='flx_fs ai_center'>
                  <a href='/braincube' onClick={() => { window.location.href = "/braincube" }}><img loading="lazy" src={braincube} className='braincubelogo' alt='Braincube Partner' /></a>
                  <Typography variant='h6' className='black fw5 mb0'> | &nbsp; Partner</Typography>
                </Box>
              </>
            ) : window.location.pathname === "/databricks" ? (
              <>
                <a href='/' onClick={() => { window.location.href = "/" }}><img loading="lazy" src={dpalogo} className='dpalogo withora' alt='Decimal Point Analytics' /></a>
                <a href='/' onClick={() => { window.location.href = "/" }}><img loading="lazy" src={smdpalogo} className='smdpalogo' alt='Decimal Point Analytics' /></a>
                <Box className='flx_fs ai_center'>
                  <a href='/databricks' onClick={() => { window.location.href = "/databricks" }}><img loading="lazy" src={databricks} className='braincubelogo' alt='Databricks Partner' /></a>
                  <Typography variant='h6' className='black fw5 mb0'> | &nbsp; Partner</Typography>
                </Box>
              </>
            ) : window.location.pathname === "/igsa-labs" ? (
              <>
                <a href='/' onClick={() => { window.location.href = "/" }}><img loading="lazy" src={dpalogo} className='dpalogo withora' alt='Decimal Point Analytics' /></a>
                <a href='/' onClick={() => { window.location.href = "/" }}><img loading="lazy" src={smdpalogo} className='smdpalogo' alt='Decimal Point Analytics' /></a>
                <Box className='flx_fs ai_center'>
                  <a href='/igsa-labs' onClick={() => { window.location.href = "/igsa-labs" }}><img loading="lazy" src={IGSALogo} className='braincubelogo igsalogo' alt='IGSA Labs Partner' /></a>
                  <Typography variant='h6' className='black fw5 mb0'> | &nbsp; Partner</Typography>
                </Box>
              </>
            ) : (
              <>
                <a href='/' onClick={() => { window.location.href = "/" }}><img loading="lazy" src={dpalogo} className='dpalogo' alt='Decimal Point Analytics' /></a>
              </>
            )}
          </Box>

          <div className="grow" />
          <div className="sectionDesktop desktopviewmenu">

            <Link to='/' className="logintitle" >
              <Button disableRipple className={`menutt ${isActive(['/']) ? 'active_menu' : ''}`}>Home</Button>
            </Link>

            <Box variant="h6" className="logintitle" aria-controls="menuId" aria-haspopup="true" onClick={handleProfileMenuOpen}>
              <Button endIcon={<ArrowDropDownIcon />} disableRipple className={`menutt ${isActive(['/data-solution-in-us', '/business-intelligence-solution', '/artificial-intelligence-solutions', '/leading-research-solution-company', '/risk-management-company-in-us', '/small-business-administration', '/catastrophe-modeling-services', '/cloud-services', '/quantum-computing', '/ecopulse', '/coffeepulse', '/creditpulse', '/analystpulse', '/fidelitypulse', '/robopulse', '/environmental-social-and-governance-for-financial-institutions-and-enterprise-businesses', '/consultant-database-management', '/crm-solutions', '/investor-relations-solutions', '/request-for-proposals-solutions', '/due-diligence-questionnaires-solutions', '/consultant-database-management-solutions', '/customer-relationship-management-solutions', '/bridge-lending-solutions', '/fund-management-and-private-equity-support-solutions']) ? 'active_menu' : ''}`}>Solutions</Button>
            </Box>

            <Menu
              anchorEl={anchorEl}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
              id={menuId}
              keepMounted
              transformOrigin={{ vertical: 'bottom', horizontal: 'right' }}
              open={isMenuOpen}
              onClose={handleMenuClose} className="menuitem solutions"
              PaperProps={{
                style: {
                  width: '20ch',
                },
              }}
            >


              <Grid container spacing={0} alignItems="top">
                <Grid item xs={12} sm={12} >
                  <Typography className="menuheading">Services</Typography>

                  <Grid container spacing={0} alignItems="top">
                    <Grid item lg={4} md={4} sm={4} xs={12}>

                      <Grid container spacing={0} alignItems="center">

                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Box className='bdd '>
                            <Box component={Link} to='/artificial-intelligence-solutions' className={`linkitem ${isActive(['/artificial-intelligence-solutions']) ? 'active_drop_menu' : ''}`}>
                              <MenuItem onClick={handleMenuClose} ><span>Artificial Intelligence</span>
                              </MenuItem>
                              <Typography className='menudscrp'>Empower your business with AI to stay ahead</Typography>
                            </Box>
                          </Box>
                        </Grid>

                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Box className='bdd '>
                            <Box component={Link} to='/bridge-lending-solutions' className={`linkitem ${isActive(['/bridge-lending-solutions']) ? 'active_drop_menu' : ''}`}>
                              <MenuItem onClick={handleMenuClose} ><span>Bridge Lending Solutions</span>
                              </MenuItem>
                              <Typography className='menudscrp'>Streamline your bridge lending operations with expert risk management and efficient processes to stay ahead in a competitive market.</Typography>
                            </Box>
                          </Box>
                        </Grid>

                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Box className='bdd  '>
                            <Box component={Link} to='/catastrophe-modeling-services' className={`linkitem ${isActive(['/catastrophe-modeling-services']) ? 'active_drop_menu' : ''}`}>
                              <MenuItem onClick={handleMenuClose} ><span>Catastrophe Modeling Services</span>
                              </MenuItem>
                              <Typography className='menudscrp'>Optimize risk strategies with CAT modeling</Typography>
                            </Box>
                          </Box>
                        </Grid>

                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Box className='bdd bddln pb3 prn ptn'>
                            <Box component={Link} to='/cloud-services' className={`linkitem ${isActive(['/cloud-services']) ? 'active_drop_menu' : ''}`}>
                              <MenuItem onClick={handleMenuClose} ><span>Cloud Services</span>
                              </MenuItem>
                              <Typography className='menudscrp'>Migration, Optimization, Monitoring & Multi-Cloud Solutions Empower Your Business with Cutting-Edge Cloud Services</Typography>
                            </Box>
                          </Box>
                        </Grid>

                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Box className='bdd bddln pb3 ptn pbn prn' >
                            <Box component={Link} to='/data-solution-in-us' className={`linkitem ${isActive(['/data-solution-in-us']) ? 'active_drop_menu' : ''}`} pb={3}>
                              <MenuItem onClick={handleMenuClose} ><span>Data Solution</span>
                              </MenuItem>
                              <Typography className='menudscrp'>Let us solve 80% of your problems</Typography>
                            </Box>
                          </Box>
                        </Grid>

                      </Grid>
                    </Grid>

                    <Grid item lg={4} md={4} sm={4} xs={12}>

                      <Grid container spacing={0} alignItems="top">

                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Box className='bdd esgbx'  >
                            <Box component={Link} onClick={handleMenuClose} to='/environmental-social-and-governance-for-financial-institutions-and-enterprise-businesses' className={`linkitem ${isActive(['/environmental-social-and-governance-for-financial-institutions-and-enterprise-businesses']) ? 'active_drop_menu' : ''}`}  >
                              <MenuItem onClick={toggleDrawer(false)}><span className='blue'>ESG</span>
                              </MenuItem>
                              <Typography className='menudscrp'>ESG solutions for sustainable growth and compliance</Typography>
                            </Box>

                            <Box className='esgopbx' py={"16px"} >

                              <Box component={Link} onClick={handleMenuClose} to='/esg-insights/esg-whitepaper' className={`linkitem ${isActive(['/esg-insights/esg-whitepaper']) ? 'active_drop_menu' : ''}`}>
                                <MenuItem onClick={toggleDrawer(false)}><span className=''>ESG Insight</span>
                                </MenuItem>
                              </Box>

                              <Box component={Link} onClick={handleMenuClose} to='/environmental-social-and-governance-for-financial-institutions-and-enterprise-businesses#esg-executable-roundtable' className={`linkitem ${isActive(['/environmental-social-and-governance-for-financial-institutions-and-enterprise-businesses#esg-executable-roundtable']) ? 'active_drop_menu' : ''}`}>
                                <MenuItem onClick={toggleDrawer(false)}><span className=''>ESG Roundtable</span>
                                </MenuItem>
                              </Box>

                              <Box component={Link} onClick={handleMenuClose} to='/empowering-esg-investment-with-real-time-analytics' className={`linkitem ${isActive(['/empowering-esg-investment-with-real-time-analytics', 'elevating-private-equity-performance-with-strategic-esg-solutions']) ? 'active_drop_menu' : ''}`}>
                                <MenuItem onClick={toggleDrawer(false)}><span className=''>ESG Products</span>
                                </MenuItem>
                              </Box>
                            </Box>

                          </Box>
                        </Grid>

                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Box className='bdd bddoall btn pbn invebx1'>
                            <Box component={Link} onClick={handleMenuClose} to='/investor-relations-solutions' className={`linkitem ${isActive(['/investor-relations-solutions']) ? 'active_drop_menu' : ''}`}  >
                              <MenuItem onClick={toggleDrawer(false)}><span>Investor Relations Solutions</span>
                              </MenuItem>

                              <Typography className='menudscrp'>Transform Your Investor Relations <br /> Today</Typography>
                            </Box>

                            <Box className='invebx' py={"16px"}>

                              <Box component={Link} onClick={handleMenuClose} to='/request-for-proposals-solutions' className={`linkitem ${isActive(['/request-for-proposals-solutions']) ? 'active_drop_menu' : ''}`}>
                                <MenuItem onClick={toggleDrawer(false)}><span>RFP Management Solutions</span>
                                </MenuItem>
                              </Box>

                              <Box component={Link} onClick={handleMenuClose} to='/due-diligence-questionnaires-solutions' className={`linkitem ${isActive(['/due-diligence-questionnaires-solutions']) ? 'active_drop_menu' : ''}`}>
                                <MenuItem onClick={toggleDrawer(false)}><span>Due Diligence questionnaires</span>
                                </MenuItem>
                              </Box>

                              <Box component={Link} onClick={handleMenuClose} to='/consultant-database-management-solutions' className={`linkitem ${isActive(['/consultant-database-management-solutions']) ? 'active_drop_menu' : ''}`}>
                                <MenuItem onClick={toggleDrawer(false)}><span>Consultant Database Management</span>
                                </MenuItem>
                              </Box>

                              <Box component={Link} onClick={handleMenuClose} to='/customer-relationship-management-solutions' className={`linkitem ${isActive(['/customer-relationship-management-solutions']) ? 'active_drop_menu' : ''}`}>
                                <MenuItem onClick={toggleDrawer(false)}><span>Customer Relationship Management</span>
                                </MenuItem>
                              </Box>
                            </Box>

                          </Box>
                        </Grid>


                      </Grid>
                    </Grid>

                    <Grid item lg={4} md={4} sm={4} xs={12}>

                      <Grid container spacing={0} alignItems="center">

                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Box className='bdd bddln pb3 prn ptn' >
                            <Box component={Link} to='/business-intelligence-solution' className={`linkitem ${isActive(['/business-intelligence-solution']) ? 'active_drop_menu' : ''}`} pb={3}>
                              <MenuItem onClick={handleMenuClose} ><span>Data Visualization & BI Dashboards</span>
                              </MenuItem>
                              <Typography className='menudscrp'>Drive strategic decisions with essential data insights</Typography>
                            </Box>
                          </Box>
                        </Grid>

                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Box className='bdd bddln pb3 prn ptn' >
                            <Box component={Link} to='/fund-management-and-private-equity-support-solutions' className={`linkitem ${isActive(['/fund-management-and-private-equity-support-solutions']) ? 'active_drop_menu' : ''}`} pb={3}>
                              <MenuItem onClick={handleMenuClose} ><span>Fund Management & PE Support Solutions</span>
                              </MenuItem>
                              <Typography className='menudscrp'>Drive strategic decisions with essential data insights and tailored solutions for fund management and private equity support.</Typography>
                            </Box>
                          </Box>
                        </Grid>

                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Box className='bdd  '>
                            <Box component={Link} to='/leading-research-solution-company' className={`linkitem ${isActive(['/leading-research-solution-company']) ? 'active_drop_menu' : ''}`}>
                              <MenuItem onClick={handleMenuClose} ><span>Research Solution</span>
                              </MenuItem>
                              <Typography className='menudscrp'>The analysis that augments your quality of decisions</Typography>
                            </Box>
                          </Box>
                        </Grid>

                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Box className='bdd '>
                            <Box component={Link} to='/risk-management-company-in-us' className={`linkitem ${isActive(['/risk-management-company-in-us']) ? 'active_drop_menu' : ''}`}>
                              <MenuItem onClick={handleMenuClose} ><span>Risk Management</span>
                              </MenuItem>
                              <Typography className='menudscrp'>The analysis that augments your quality of decisions</Typography>
                            </Box>
                          </Box>
                        </Grid>

                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Box className='bdd bddln pb3 ptn prn pbn'>
                            <Box component={Link} to='/small-business-administration' className={`linkitem ${isActive(['/small-business-administration']) ? 'active_drop_menu' : ''}`}>
                              <MenuItem onClick={handleMenuClose} ><span>Small Business Administration</span>
                              </MenuItem>
                              <Typography className='menudscrp'>Streamline SBA lending with precision and efficiency</Typography>
                            </Box>
                          </Box>
                        </Grid>

                      </Grid>
                    </Grid>


                  </Grid>



                </Grid>
              </Grid>
            </Menu>


            <Box variant="h6" className="logintitle" aria-controls="simple-menu" aria-haspopup="true" onClick={handleClickins}>
              <Button endIcon={<ArrowDropDownIcon />} disableRipple className={`menutt ${isActive(['/case-studies', '/articles', '/blog', '/newsletter', '/podcast', '/whitepaper', '/magazine']) ? 'active_menu' : ''}`}>Insights</Button>
            </Box>

            <Menu
              id="menuId"
              anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
              transformOrigin={{ vertical: 'bottom', horizontal: 'right' }}
              anchorEl={anchorEins}
              keepMounted
              open={Boolean(anchorEins)}
              onClose={handleCloseins} className="insight_menu"

            >

              <Box className='bdd'>
                <Box component={Link} to='/case-studies' className={`linkitem ${isActive(['/case-studies']) ? 'active_drop_menu' : ''}`}>
                  <MenuItem onClick={handleCloseins} ><span> Success Stories </span>
                  </MenuItem>
                </Box>
              </Box>


              <Box className='bdd'>
                <Box component={Link} to='/articles' className={`linkitem ${isActive(['/articles']) ? 'active_drop_menu' : ''}`}>
                  <MenuItem onClick={handleCloseins} ><span> Articles </span>
                  </MenuItem>
                </Box>
              </Box>

              <Box className='bdd'>
                <Box component={Link} to='/blog' className={`linkitem ${isActive(['/blog']) ? 'active_drop_menu' : ''}`}>
                  <MenuItem onClick={handleCloseins} ><span> Blogs </span>
                  </MenuItem>
                </Box>
              </Box>

              <Box className='bdd'>
                <Box component={Link} to='/newsletter' className={`linkitem ${isActive(['/newsletter']) ? 'active_drop_menu' : ''}`}>
                  <MenuItem onClick={handleCloseins} ><span> Newsletter </span>
                  </MenuItem>
                </Box>
              </Box>

              <Box className='bdd'>
                <Box component={Link} to='/podcast' className={`linkitem ${isActive(['/podcast']) ? 'active_drop_menu' : ''}`}>
                  <MenuItem onClick={handleCloseins} ><span> Podcast </span>
                  </MenuItem>
                </Box>
              </Box>

              {/* <Box className='bdd'>
                <Box component={Link} to='/infographics' className={`linkitem ${isActive(['/infographics']) ? 'active_drop_menu' : ''}`}>
                  <MenuItem onClick={handleCloseins} ><span> Infographic </span>
                  </MenuItem>
                </Box>
              </Box> */}

              <Box className='bdd'>
                <Box component={Link} to='/whitepaper' className={`linkitem ${isActive(['/whitepaper']) ? 'active_drop_menu' : ''}`}>
                  <MenuItem onClick={handleCloseins} ><span> Whitepapers </span>
                  </MenuItem>
                </Box>
              </Box>

              <Box>
                <Box component={Link} to='/magazine' className={`linkitem ${isActive(['/magazine']) ? 'active_drop_menu' : ''}`}>
                  <MenuItem onClick={handleCloseins} ><span> Magazine </span>
                  </MenuItem>
                </Box>
              </Box>

            </Menu>


            {/* <Link to='/careers' variant="h6" className="logintitle" > */}
            <Link to='/life-as-a-decimal' className="logintitle">
              <Button disableRipple className={`menutt ${isActive(['/life-as-a-decimal', '/our-culture', '/journey-of-a-decimal', '/dnyanodapi-dhanodapi', '/current-openings']) ? 'active_menu' : ''}`}>Careers</Button>
            </Link>


            <Box variant="h6" className="logintitle" aria-controls="simple-menu" aria-haspopup="true" onClick={handleClickOra}>
              <Button endIcon={<ArrowDropDownIcon />} disableRipple className={`menutt ${isActive(['/oracle', '/ibm', '/clickup-partnership', '/salesforce-crm-solutions', '/braincube', '/databricks', '/igsa-labs']) ? 'active_menu' : ''}`}>Partners</Button>
            </Box>

            <Menu
              id="menuId"
              anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
              transformOrigin={{ vertical: 'bottom', horizontal: 'right' }}
              anchorEl={anchorEOra}
              keepMounted
              open={Boolean(anchorEOra)}
              onClose={handleCloseOra} className="insight_menu partner_section"
            >


              <Box className='bdd'>
                <Box component={Link} to='/oracle' className={`linkitem ${isActive(['/oracle']) ? 'active_drop_menu' : ''}`}>
                  <MenuItem onClick={handleCloseOra} ><span className='fx_c'>
                    <ListItemIcon>
                      <img loading="lazy" src={smoracle} className='sm_partner_logo' alt='Oracle' />
                    </ListItemIcon>Oracle</span>
                  </MenuItem>
                </Box>
              </Box>

              <Box className='bdd'>
                <Box component={Link} to='/ibm' className={`linkitem ${isActive(['/ibm']) ? 'active_drop_menu' : ''}`}>
                  <MenuItem onClick={handleCloseOra} ><span className='fx_c'>
                    <ListItemIcon>
                      <img loading="lazy" src={smibm} className='sm_partner_logo' alt='Oracle' />
                    </ListItemIcon>IBM</span>
                  </MenuItem>
                </Box>
              </Box>

              <Box className='bdd'>
                <Box component={Link} to='/clickup-partnership' className={`linkitem ${isActive(['/clickup-partnership']) ? 'active_drop_menu' : ''}`}>
                  <MenuItem onClick={handleCloseOra} ><span className='fx_c'>
                    <ListItemIcon>
                      <img loading="lazy" src={smclickup} className='sm_partner_logo' alt='Oracle' />
                    </ListItemIcon>ClickUp</span>
                  </MenuItem>
                </Box>
              </Box>

              <Box className='bdd'>
                <Box component={Link} to='/salesforce-crm-solutions' className={`linkitem ${isActive(['/salesforce-crm-solutions']) ? 'active_drop_menu' : ''}`}>
                  <MenuItem onClick={handleCloseOra} ><span className='fx_c'>
                    <ListItemIcon>
                      <img loading="lazy" src={smsalesforce} className='sm_partner_logo' alt='Salesforce' />
                    </ListItemIcon>Salesforce</span>
                  </MenuItem>
                </Box>
              </Box>

              <Box className='bdd'>
                <Box component={Link} to='/braincube' className={`linkitem ${isActive(['/braincube']) ? 'active_drop_menu' : ''}`}>
                  <MenuItem onClick={handleCloseOra} ><span className='fx_c'>
                    <ListItemIcon>
                      <img loading="lazy" src={smbraincube} className='sm_partner_logo' alt='Braincube' />
                    </ListItemIcon>Braincube</span>
                  </MenuItem>
                </Box>
              </Box>

              <Box className='bdd'>
                <Box component={Link} to='/databricks' className={`linkitem ${isActive(['/databricks']) ? 'active_drop_menu' : ''}`}>
                  <MenuItem onClick={handleCloseOra} ><span className='fx_c'>
                    <ListItemIcon>
                      <img loading="lazy" src={smdatabricks} className='sm_partner_logo' alt='Databricks' />
                    </ListItemIcon>Databricks</span>
                  </MenuItem>
                </Box>
              </Box>

              <Box className=''>
                <Box component={Link} to='/igsa-labs' className={`linkitem ${isActive(['/igsa-labs']) ? 'active_drop_menu' : ''}`}>
                  <MenuItem onClick={handleCloseOra} ><span className='fx_c'>
                    <ListItemIcon>
                      <img loading="lazy" src={IGSALogosm} className='sm_partner_logo' alt='IGSA Labs' />
                    </ListItemIcon>IGSA Labs</span>
                  </MenuItem>
                </Box>
              </Box>

            </Menu>


            <Box variant="h6" className="logintitle" aria-controls="simple-menu" aria-haspopup="true" onClick={handleClick}>
              <Button endIcon={<ArrowDropDownIcon />} disableRipple className={`menutt ${isActive(['/who-we-are', '/decimal-sutras', '/awards', '/management', '/csr', '/energy-efficiency', '/event', '/newsroom/media-feature']) ? 'active_menu' : ''}`}>About Us</Button>
            </Box>

            <Menu
              id="menuId"
              anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
              transformOrigin={{ vertical: 'bottom', horizontal: 'right' }}
              anchorEl={anchorE2}
              keepMounted
              open={Boolean(anchorE2)}
              onClose={handleClose} className="menuitem"
            >


              <Grid container spacing={4} alignItems="top">
                <Grid item xs={12} sm={6}>

                  <Box className='bdd'>
                    <Box component={Link} to='/who-we-are' className={`linkitem ${isActive(['/who-we-are']) ? 'active_drop_menu' : ''}`}>
                      <MenuItem onClick={handleClose} ><span>Our Story & Offerings</span>
                      </MenuItem>
                    </Box>
                  </Box>

                  <Box className='bdd'>
                    <Box component={Link} to='/decimal-sutras' className={`linkitem ${isActive(['/decimal-sutras']) ? 'active_drop_menu' : ''}`}>
                      <MenuItem onClick={handleClose} ><span>Decimal Sutras</span>
                      </MenuItem>
                    </Box>
                  </Box>

                  <Box className='bdd'>
                    <Box component={Link} to='/awards' className={`linkitem ${isActive(['/awards']) ? 'active_drop_menu' : ''}`}>
                      <MenuItem onClick={handleClose} ><span>Awards and Accolades</span>
                      </MenuItem>
                    </Box>
                  </Box>

                  {/* <Box className='bdd'>
                    <Box component={Link} to='/technologyedge' className={`linkitem ${isActive(['/technologyedge']) ? 'active_drop_menu' : ''}`}>
                      <MenuItem onClick={handleClose} ><span>The Technology Edge</span>
                      </MenuItem>
                    </Box>
                  </Box>

                  <Box className='bdd'>
                    <Box component={Link} to='/valueproposition' className={`linkitem ${isActive(['/valueproposition']) ? 'active_drop_menu' : ''}`}>
                      <MenuItem onClick={handleClose} ><span>Value Proposition</span>
                      </MenuItem>
                    </Box>
                  </Box> */}

                  <Box className='bdd'>
                    <Box component={Link} to='/management' className={`linkitem ${isActive(['/management']) ? 'active_drop_menu' : ''}`}>
                      <MenuItem onClick={handleClose} ><span>Management Team</span>
                      </MenuItem>
                    </Box>
                  </Box>

                </Grid>


                <Grid item xs={12} sm={6}>

                  {/* <Box className='bdd'>
                    <Box component={Link} to='/structure-innovation' className={`linkitem ${isActive(['/structure-innovation']) ? 'active_drop_menu' : ''}`}>
                      <MenuItem onClick={handleClose} ><span>Structure of Innovation</span>
                      </MenuItem>
                    </Box>
                  </Box> */}

                  <Box className='bdd'>
                    <Box component={Link} to='/csr' className={`linkitem ${isActive(['/csr']) ? 'active_drop_menu' : ''}`}>
                      <MenuItem onClick={handleClose} ><span>CSR</span>
                      </MenuItem>
                    </Box>
                  </Box>

                  <Box className='bdd'>
                    <Box component={Link} to='/energy-efficiency' className={`linkitem ${isActive(['/energy-efficiency']) ? 'active_drop_menu' : ''}`}>
                      <MenuItem onClick={handleClose} ><span>Energy Efficiency</span>
                      </MenuItem>
                    </Box>
                  </Box>
                  <Box className='bdd'>
                    <Box component={Link} to='/event' className={`linkitem ${isActive(['/event']) ? 'active_drop_menu' : ''}`}>
                      <MenuItem onClick={handleClose} ><span>Events</span>
                      </MenuItem>
                    </Box>
                  </Box>

                  <Box className='bdd'>
                    <Box component={Link} to='/newsroom/media-feature' className={`linkitem ${isActive(['/newsroom/media-feature']) ? 'active_drop_menu' : ''}`}>
                      <MenuItem onClick={handleClose} ><span>News Room</span>
                      </MenuItem>
                    </Box>
                  </Box>


                </Grid>
              </Grid>

            </Menu>

            <LetsConnectCTA className="contact_sales_btn" btn_name="Contact Sales" />
            {/* </Link> */}


          </div>


          <Box className='mobileviewmenu'>
            {['right'].map((anchor) => (
              <React.Fragment>


                <IconButton aria-label="delete" onClick={toggleDrawer(anchor, true)}>
                  <MenuIcon fontSize="small" color='primary' />
                </IconButton>
                <Drawer
                  className='drawer'
                  anchor={anchor}
                  open={state[anchor]}
                  onClose={toggleDrawer(anchor, false)}
                >
                  {list(anchor)}
                </Drawer>
              </React.Fragment>
            ))}
          </Box>

        </Toolbar>
      </AppBar>

    </div >



  );
}
